import BaseService from './BaseService'
import { api } from '../boot/axios'

class POSService extends BaseService {
  constructor() {
    super('/sales')
  }

  async createSale(saleData) {
    return this.customRequest('post', '', saleData)
  }

  async getSale(id) {
    return this.customRequest('get', `/${id}`)
  }

  async getSales(params = {}) {
    return this.customRequest('get', '', null, { params })
  }


  async getTransactions() {
    return this.customRequest('get', '/transactions')
  }

  async generateReceipt(saleId) {
    return this.customRequest('get', `/${saleId}/receipt`)
  }

  /**
   * Authenticated PDF bytes (same as public signed receipt PDF).
   * @param {number|string} saleId
   * @returns {Promise<Blob>}
   */
  async downloadReceiptPdf(saleId) {
    const response = await api.get(`${this.baseURL}/${saleId}/receipt/pdf`, {
      responseType: 'blob',
    })
    return response.data
  }

  async reprintReceipt(saleId) {
    return this.customRequest('post', `/${saleId}/reprint`)
  }

  async emailReceipt(saleId, payload) {
    return this.customRequest('post', `/${saleId}/receipt/email`, payload)
  }

  async smsReceipt(saleId, payload) {
    return this.customRequest('post', `/${saleId}/receipt/sms`, payload)
  }

  async updateSaleStatus(saleId, status) {
    return this.customRequest('put', `/${saleId}/status`, { status })
  }

  async voidSale(saleId) {
    return this.customRequest('post', `/${saleId}/void`)
  }

  async unvoidSale(saleId) {
    return this.customRequest('post', `/${saleId}/unvoid`)
  }

  async getInventoryImpact(saleId) {
    const sale = await this.getSale(saleId)

    if (!sale || !sale.items) {
      return []
    }

    return sale.items.filter(item => item.product && !item.product.non_stock)
      .map(item => ({
        id: item.product.id,
        name: item.product.name,
        quantity: item.quantity,
        stock: item.product.stock
      }))
  }
}

export const posService = new POSService()
